import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-non-school-day-warning',
  templateUrl: './non-school-day-warning.component.html'
})
export class NonSchoolDayWarningComponent implements OnInit {

  dates: Date[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<NonSchoolDayWarningComponent>,
  ) {
    if (data) {
      this.dates = data.dates;
    }
  }

  ngOnInit() {

  }

  continueClick() {
    this.dialog.close(true);
  }

  cancelClick() {
    this.dialog.close(false);
  }

}
